import React, { useEffect } from "react"
import NavBar from "../general/navbar"
import TagLine from "./tagline"
import BlogSection from "./blogsection"
import ContactSection from "./contactsection"
import Testimonials from "./testimonials"
import getFirebase from "../../utils/firebase.js"
import Footer from "../general/footer"
import Affiliatesection from "../general/affiliatesection"
import Featuresection from "./featuressection"
import Clipssection from "./clipssection"
import Audioeditsection from "./audioeditsection"
import Agenciessection from "./agenciessection"
import Asseenon from "../general/asseenon"
import Podcastvideosection from "./podcastvideosection"
import Translate from '../general/translate'

const Main = () => {
  useEffect(() => {
    const firebase = getFirebase();
  }, []);
  
  return (
    <div className="bg-[#27004F]">       
      <NavBar/>
      <TagLine/>
      <Asseenon/>
      <Featuresection/>
      <Clipssection/>
      <Audioeditsection/>
      <Agenciessection/> 
      <Podcastvideosection/>          
      <BlogSection/>      
      <Testimonials/>
      <Affiliatesection/>
      <ContactSection/>
      <Footer/>
    </div>
  )
}

export default Main